import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Form} from 'formik';
import FieldInput from '../../components/FieldInput';
import FieldFileUpload from '../../components/FieldFileUpload';
import Button from '../../components/Button';
import ButtonShowModal from '../../components/ButtonShowModal';
import LabelInfo from '../../components/LabelInfo';
import ErrorValidation from '../../components/ErrorValidation';
import infoIcon from '../../assets/icon-info.svg';
import docIcon from '../../assets/icon-file-upload.svg';
import config from '../../config/common';
import styles from './styles.module.scss';

const Explanations = () => (
  <ButtonShowModal
    label={(
      <div className={styles.explanationLabel}>
        <img src={infoIcon} alt="info"/>
        <div className={`${styles.info}`}>
          <FormattedMessage
            id='step15.form.explanations.info'
            defaultMessage='Explanations'
          />
        </div>
      </div>
    )}
    headerContent={(
      <FormattedMessage
        id={'step15.form.explanations.modal.header'}
        defaultMessage={'Explanations of tax adjustment'}
      />
    )}
  >
    {() => (
      <>
        <div className={`${styles.text} ${styles.modal}`}>
          <div className={`${styles.contentBlock} ${styles.text}`}>
            <div>
              <FormattedMessage
                id={'step15.form.explanations.modal.link'}
                defaultMessage={'Click on the link '}
              />
            </div>
            <div>
              <a href={'https://secapp.taxes.gov.il/logon/LogonPoint/tmindex.html'} target="_blank"
                 className={styles.link}>
                <FormattedMessage
                  id={'step15.form.explanations.modal.link.label'}
                  defaultMessage={'Link'}
                />
              </a>
            </div>
          </div>
          {
            new Array(23)
              .fill(":)")
              .map((_, index) => {
                const textIndex = index + 1;
                switch (textIndex) {
                  case 14:
                    return (
                      <div key={index} className={`${styles.text} ${styles.contentBlock}`}>
                        <div className={styles.littleBottomMargin}>
                          <FormattedMessage
                            id={`step15.form.explanations.modal.text.14.1`}
                          />
                        </div>
                        <div className={styles.littleBottomMargin}>
                          <FormattedMessage
                            id={`step15.form.explanations.modal.text.14.2`}
                          />
                        </div>
                        <div className={styles.littleBottomMargin}>
                          <FormattedMessage
                            id={`step15.form.explanations.modal.text.14.3`}
                          />
                        </div>
                        <div className={styles.littleBottomMargin}>
                          <FormattedMessage
                            id={`step15.form.explanations.modal.text.14.4`}
                          />
                        </div>
                      </div>
                    );
                  default:
                    return (
                      <div key={index} className={`${styles.text} ${styles.contentBlock}`}>
                        <FormattedMessage
                          id={`step15.form.explanations.modal.text.${textIndex}`}
                        />
                      </div>
                    );
                }
              })
          }
        </div>
      </>
    )}
  </ButtonShowModal>
);

const Step15View = ({
                      copyNumber,
                      onOutlineBtnClick,
                      isValid,
                      fileTypes,
                      onChange,
                    }) => {
  return (
    <Form className={styles.formContainer}>
      <div className={styles.innerPadding}>
        <div className={styles.input}>
          <div className={styles.titleBold}>
            <FormattedMessage
              id='step15.form.title'
            />
          </div>
        </div>
        <div className={styles.input}>
          <div className={`${styles.input} ${styles.text}`}>
            <FormattedMessage
              id={'step15.form.note.taxAdjustment.1'}
              defaultMessage={'You must go to the income tax website and make a tax adjustment.'}
            />
          </div>
          <div className={`${styles.input} ${styles.text}`}>
            <FormattedMessage
              id={'step15.form.note.taxAdjustment.2'}
              defaultMessage={'Which needs a PDF at the end of the process you will get a file to upload here.'}
            />
          </div>
          <div className={`${styles.input} ${styles.text}`}>
            <FormattedMessage
              id={'step15.form.note.taxAdjustment.3'}
            />
          </div>
          <div className={`${styles.input} ${styles.text} ${styles.bold}`}>
            <FormattedMessage
              id={'step15.form.note.taxAdjustment.4'}
              defaultMessage={'Without this tax coordination, we will not be able to pay you.'}
            />
          </div>
        </div>
      </div>
      <div className={`${styles.innerPadding} ${styles.input}`}>
        <div className={styles.twoInRow}>
          <LabelInfo
            label={(
              <FormattedMessage
                id={'step15.form.question.label'}
                defaultMessage={'What should be done?'}
              />
            )}
            className={styles.textBig}
          />
          <Explanations/>
        </div>
      </div>
      <div className={`${styles.innerPadding} ${styles.input}`}>
        <div className={styles.item}>
          <FormattedMessage
            id={'step15.form.item.1.label'}
            defaultMessage={'Leave this window open'}
          />
        </div>
      </div>
      <div className={`${styles.innerPadding} ${styles.input}`}>
        <div className={styles.item}>
          <FormattedMessage
            id={'step15.form.item.2.label.1'}
            defaultMessage={'Copy our deduction file number'}
          />
          <div className={styles.containerWithCopy}>
            <div className={styles.copy}>
              <Button
                variant={'secondary'}
                type={'button'}
                label={(
                  <FormattedMessage
                    id={'step15.form.copy.label'}
                    defaultMessage={'Copy'}
                  />
                )}
                onClick={copyNumber}
              />
            </div>
            <FieldInput
              fieldId={'fileNumber'}
              disabled={true}
              value={config.deductionFileNumber}
            />
          </div>
        </div>
      </div>
      <div className={`${styles.innerPadding} ${styles.input}`}>
        <div className={styles.item}>
          <FormattedMessage
            id={'step15.form.item.3.label'}
            defaultMessage={'Go to the Income Tax website for tax coordination'}
          />
        </div>
        <a href={'https://secapp.taxes.gov.il/logon/LogonPoint/tmindex.html'} target="_blank"
           className={styles.taxSiteLink}>
          <FormattedMessage
            id={'step15.form.taxSiteLink.label'}
            defaultMessage={'Go to the IRS website'}
          />
        </a>
      </div>
      <div className={`${styles.innerPadding} ${styles.input}`}>
        <div className={`${styles.item} ${styles.input}`}>
          <FormattedMessage
            id={'step15.form.item.4.label'}
            defaultMessage={'You received an income tax PDF uploaded the'}
          />
        </div>
        <FieldFileUpload
          fieldId={'pdf'}
          accept={fileTypes}
          cameraLabel={(
            <FormattedMessage
              id='common.form.uploadFile.note'
              defaultMessage='File uploading'
            />
          )}
          icon={docIcon}
          onChange={onChange}
        />
      </div>
      <div className={styles.innerPadding}>
        <Button
          type='submit'
          label={(
            <FormattedMessage
              id='common.form.button.save'
              defaultMessage='Save'
            />
          )}
          className={styles.buttonSave}
        />
        {!isValid && <ErrorValidation/>}
        <div className={styles.outlineBtn}>
          <Button
            type={'button'}
            variant={'secondary'}
            onClick={onOutlineBtnClick}
            label={(
              <FormattedMessage
                id={'step15.form.taxAdjustment.button'}
                defaultMessage={'I will transfer tax coordination later'}
              />
            )}
          />
        </div>
      </div>
    </Form>
  )
};

Step15View.propTypes = {
  copyNumber: PropTypes.func,
  onOutlineBtnClick: PropTypes.func,
  isValid: PropTypes.bool,
  fileTypes: PropTypes.string,
};

export default Step15View;
